import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { PERMISSIONS } from 'constants/permissions';
import { Button, Col, HasAccess, Popconfirm, Row, Typography } from 'components';
import { CopyOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import styles from './styles.module.scss';

interface CardHeaderProps {
  createDate: string | undefined;
  attachments?: Record<string, any>;
  lastModifiedDate: string | undefined;
  formattedCreateDate?: string;
  formattedLastModifiedDate?: string;
  onCreateCopy: (e: React.MouseEvent) => void;
  onDelete: () => void;
  displayDate: (date: string) => string;
  isInFinalStatus: boolean;
}

const { Text } = Typography;

export const CardHeader: React.FC<CardHeaderProps> = memo(
  ({
    createDate,
    attachments,
    lastModifiedDate,
    formattedCreateDate,
    formattedLastModifiedDate,
    onCreateCopy,
    onDelete,
    displayDate,
    isInFinalStatus,
  }) => {
    return (
      <Row className={'margin-b-20'} justify={'space-between'}>
        <Text type="secondary" className={styles.dates}>
          Created Date: {formattedCreateDate || (createDate ? displayDate(createDate) : '-')} | Last Updated Date:{' '}
          {formattedLastModifiedDate || (lastModifiedDate ? displayDate(lastModifiedDate) : '-')}
        </Text>
        <Col span={5} className={styles.headerButtons}>
          {attachments ? (
            <Link to={attachments?.files?.ATTACHMENTS || ''}>
              <Button type="text" icon={<DownloadOutlined />} className={styles.iconButton}>
                Download Offer
              </Button>
            </Link>
          ) : (
            ''
          )}
          <HasAccess role={PERMISSIONS.deals.commercialOffers.write}>
            <Button type="text" icon={<CopyOutlined />} onClick={onCreateCopy} className={styles.iconButton}>
              Create a Copy
            </Button>
          </HasAccess>
          <HasAccess role={PERMISSIONS.deals.commercialOffers.delete}>
            <Popconfirm
              title="Are you sure you want to delete this Offer?"
              onConfirm={onDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button type="text" icon={<DeleteOutlined />} disabled={isInFinalStatus} className={styles.iconButton} />
            </Popconfirm>
          </HasAccess>
        </Col>
      </Row>
    );
  }
);
